export type TransactionCheckResponseDto = {
  public_key_id: string;
  descriptor: string;
};
